export default function NgoDetails(props) {
	return (
		<div className="card w-100 b-radius b-shadow mb-4 my-3">
			<div className="card-body">
				<div className="fs-4 mb-3">NGO details</div>

				<div className="d-flex justify-content-between align-items-center mb-3">
					<span>Accept date</span>
					<span>{props?.data?.accept_date}</span>
				</div>
				<div className="d-flex justify-content-between align-items-center mb-3">
					<span>Fired date</span>
					<span>{props?.data?.fired_date}</span>
				</div>
				<div className="d-flex justify-content-between align-items-center mb-3">
					<span>NGO Accept date</span>
					<span>{props?.data?.ngo_accept_date}</span>
				</div>
				<div className="d-flex justify-content-between align-items-center mb-3">
					<span>NGO Fired date</span>
					<span>{props?.data?.ngo_fired_date}</span>
				</div>
			</div>
		</div>
	);
}
